// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"63f58af8","200":"eb342384","453":"0c626c0a","470":"3b467823","787":"bb20b309","886":"20de81a3","945":"9d7e3a27"}[chunkId] + ".chunk.js";
};